import ApiClient from '@package/services/src/ApiClient';
import Result from '@package/services/src/Result';
import config from 'config-base';

import { ContentService } from './services';
import { ContentResponse } from './types';

export default class ContentApiService implements ContentService {
  public constructor(private readonly apiClient: ApiClient) {}

  public async getFreeSHTotalRetail(): Promise<Result<number | undefined>> {
    try {
      const brandPrefix = config.brandCode === '2' ? 'AGD_' : '';
      const res = await this.apiClient.get(`/content/promotion-timers/${brandPrefix}FreeSHTotalRetail`);
      const json: ContentResponse<number> = await res.json();
      return new Result(json.content);
    } catch (error) {
      console.error('FreeSHTotalRetail was not received', error);
      return new Result(undefined);
    }
  }

  public async getFreeSHTotalRetailAGD(): Promise<Result<number | null | undefined>> {
    try {
      const res = await this.apiClient.get('/content/promotion-timers/AGD_FreeSHTotalRetail');
      const json: ContentResponse<number> = await res.json();
      return new Result(json.content);
    } catch (error) {
      console.error('FreeSHTotalRetail AGD was not received', error);
      return new Result(null);
    }
  }

  public async getFreeShippingModalTemplate(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/pages/ground_transit_days_popup');
      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      console.error('Free shipping modal template was not received', error);
      return new Result(undefined);
    }
  }

  public async getPageStyleCSS(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/page-style');
      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      console.error('Custom CSS style is not received', error);
      return new Result(undefined);
    }
  }

  public async get404Template(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/messages/404SEO');
      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      console.error('404 Content was not received', error);
      return new Result(undefined);
    }
  }
  public async get404EditUrl(): Promise<Result<string | undefined>> {
    try {
      const res = await this.apiClient.get('/content/messages/404SEO/edit-url');
      const json: ContentResponse<string> = await res.json();

      return new Result(json.content);
    } catch (error) {
      console.error('404 edit url was not received', error);
      return new Result(undefined);
    }
  }
}
